import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "./assets/i18n/en";
import { es } from "./assets/i18n/es";
import 'intl-pluralrules'

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    es: {
        translation: es
    },
    en: {
        translation: en
    }
};

const language = "es"

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        compatibilityJSON: 'v3', // this is for Android
        resources,
        lng: language ? language : (window && window.navigator.language ? window.navigator.language.substring(0, 2) : 'en'),

        interpolation: {
            escapeValue: false // react already safes from xss
        },

    });

export default i18n;
